function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_280_9777)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 140C108.66 140 140 134.165 140 126.967C140 119.77 108.66 113.935 70 113.935C31.3401 113.935 0 119.77 0 126.967C0 134.165 31.3401 140 70 140Z",
  fill: "#F5F5F7",
  fillOpacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.999 85.6799L101.297 55.3872C100.112 53.9613 98.3792 53.0981 96.5547 53.0981H43.4432C41.6198 53.0981 39.8873 53.9613 38.702 55.3872L14.0006 85.6799V101.506H126V85.6799H125.999Z",
  fill: "#AEB8C2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.9293 0H105.07C106.165 0 107.215 0.43356 107.99 1.2053C108.765 1.97704 109.2 3.02375 109.2 4.11516V100.146C109.2 101.238 108.765 102.285 107.99 103.056C107.215 103.828 106.165 104.262 105.07 104.262H34.9293C33.8339 104.262 32.7834 103.828 32.0089 103.056C31.2344 102.285 30.7993 101.238 30.7993 100.146V4.11516C30.7993 3.02375 31.2344 1.97704 32.0089 1.2053C32.7834 0.43356 33.8339 0 34.9293 0V0Z",
  fill: "#F5F5F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.9342 11.2396H44.0648C43.5171 11.2396 42.9919 11.4563 42.6046 11.8422C42.2174 12.2281 41.9998 12.7514 41.9998 13.2971V38.9726C41.9998 39.5183 42.2174 40.0417 42.6046 40.4276C42.9919 40.8134 43.5171 41.0302 44.0648 41.0302H95.9342C96.4819 41.0302 97.0071 40.8134 97.3944 40.4276C97.7816 40.0417 97.9992 39.5183 97.9992 38.9726V13.2971C97.9992 12.7514 97.7816 12.2281 97.3944 11.8422C97.0071 11.4563 96.4819 11.2396 95.9342 11.2396Z",
  fill: "#DCE0E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.6637 52.1998H44.3353C43.7159 52.1998 43.1218 52.445 42.6838 52.8814C42.2459 53.3178 41.9998 53.9097 41.9998 54.5269C41.9998 55.1441 42.2459 55.736 42.6838 56.1724C43.1218 56.6089 43.7159 56.854 44.3353 56.854H95.6637C96.2831 56.854 96.8771 56.6089 97.3151 56.1724C97.7531 55.736 97.9992 55.1441 97.9992 54.5269C97.9992 53.9097 97.7531 53.3178 97.3151 52.8814C96.8771 52.445 96.2831 52.1998 95.6637 52.1998Z",
  fill: "#DCE0E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.6637 64.3014H44.3353C43.7157 64.3014 43.1216 64.5467 42.6835 64.9832C42.2454 65.4197 41.9993 66.0117 41.9993 66.6291C41.9993 67.2464 42.2454 67.8384 42.6835 68.275C43.1216 68.7115 43.7157 68.9567 44.3353 68.9567H95.6637C96.2832 68.9567 96.8774 68.7115 97.3155 68.275C97.7536 67.8384 97.9997 67.2464 97.9997 66.6291C97.9997 66.0117 97.7536 65.4197 97.3155 64.9832C96.8774 64.5467 96.2832 64.3014 95.6637 64.3014Z",
  fill: "#DCE0E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.771 122.056C124.971 125.215 122.161 127.57 118.817 127.57H21.1816C17.8384 127.57 15.028 125.214 14.2288 122.056C14.0764 121.454 13.9994 120.835 13.9996 120.214V85.6809H41.1728C44.1742 85.6809 46.5934 88.1994 46.5934 91.257V91.2981C46.5934 94.3546 49.0404 96.8227 52.0418 96.8227H87.9572C90.9586 96.8227 93.4056 94.332 93.4056 91.2744V91.2621C93.4056 88.2045 95.8248 85.6799 98.8262 85.6799H125.999V120.215C125.999 120.85 125.92 121.466 125.771 122.056Z",
  fill: "#DCE0E6"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_280_9777"
}, /*#__PURE__*/React.createElement("rect", {
  width: 140,
  height: 140,
  fill: "white"
})));

function SvgNoData1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData1);
export default __webpack_public_path__ + "static/media/no-data-1.a835cc95.svg";
export { ForwardRef as ReactComponent };